import React from 'react'

const About = () => {
  return (
    <div className='bg-zinc-900 py-4' id='about'>
        <h1 className='text-white my-8 text-4xl md:mx-64 text-center md:text-left font-bold'>About Me</h1>
        <p className='md:mx-64 ml-4 mx-6 text-xl md:text-2xl mb-8 md:leading-loose leading-loose text-white'>I am an aspiring young acheiver who is zelous enough to overcome whatever is thrown at him and reach the zenith of the work. I love challenges and solving critical conditions in a given time. Other than that, I can work in multiple fields and manage to produce an output by whatever is thrown at me.</p>

    </div>
  )
}

export default About